import { Tag } from 'antd'

import { PersonCaseStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: PersonCaseStatus | null
}

const ColorMap: Record<PersonCaseStatus, string> = {
  [PersonCaseStatus.POSSIBLE_CASE]: 'warning',
  [PersonCaseStatus.PROBABLE_CASE]: 'orange',
  [PersonCaseStatus.CONFIRMED_CASE]: 'error'
}

export const CaseStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return null

  return (
    <Tag color={ColorMap[status]}>{t(`persons.case_status.${status}`)}</Tag>
  )
}
